/**
 * FeatureGrid — the dense "tout ce que Karexia fait" grid. Every platform
 * capability as a compact tile (icon chip + label + one-line description),
 * lifting gently on hover. Sits on a tinted band to break the page rhythm.
 */

import { CAPABILITIES } from '@/routes/landing/landing-data';
import { Icon, SectionHeading } from './shared';
import { useT } from '@/i18n';

export function FeatureGrid() {
  const { t } = useT();
  return (
    <section id="capacites" className="relative overflow-hidden bg-surface-2/40 py-16 sm:py-20 lg:py-24">
      <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={t('routes.landing.sectionsFeatureGrid.everythingKarexiaDoes')}
          title={t('routes.landing.sectionsFeatureGrid.aCompleteMarketingToolbox')}
          subtitle={t('routes.landing.sectionsFeatureGrid.replaceADozenToolsWithA')}
        />

        <ul className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {CAPABILITIES.map((cap) => (
            <li key={cap.label}>
              <div className="group flex h-full items-start gap-3 rounded-token-lg border border-border bg-surface p-4 shadow-elevation-1 transition duration-200 ease-out hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-elevation-2 motion-reduce:transition-none motion-reduce:hover:translate-y-0">
                <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-token bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                  <Icon name={cap.icon} className="h-5 w-5" strokeWidth={1.9} />
                </span>
                <div className="min-w-0">
                  <p className="font-semibold text-foreground">{cap.label}</p>
                  <p className="mt-0.5 text-sm leading-relaxed text-muted">{cap.description}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
